import { ArdoqId } from '@ardoq/api-types';

type ComposeComponentsIdsArgs = {
  hierarchy: Record<ArdoqId, { isFilteredOut: boolean; children?: ArdoqId[] }>;
  children: ArdoqId[];
  limit?: number;
};

export const composeComponentsIds = ({
  hierarchy,
  children,
  limit = Infinity,
}: ComposeComponentsIdsArgs): ArdoqId[] => {
  let remainingLimit = limit;

  return children.reduce<ArdoqId[]>((componentIdsSoFar, id) => {
    const node = hierarchy[id];
    if (!node) {
      return componentIdsSoFar;
    }
    const { isFilteredOut, children: itemChildren = [] } = node;

    if (remainingLimit <= 0) {
      return componentIdsSoFar;
    }

    const hasChildren = Boolean(itemChildren && itemChildren.length > 0);

    if (!isFilteredOut) {
      componentIdsSoFar.push(id);
      remainingLimit--;
    }

    if (hasChildren) {
      const childIds = composeComponentsIds({
        hierarchy,
        children: itemChildren,
        limit: remainingLimit,
      });

      for (const childId of childIds) {
        if (remainingLimit <= 0) {
          break;
        }

        componentIdsSoFar.push(childId);
        remainingLimit--;
      }
    }

    return componentIdsSoFar;
  }, []);
};
